var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
export const getAuthStore = () => __awaiter(void 0, void 0, void 0, function* () {
    const sKeys = yield SecureStoragePlugin.keys();
    if (!sKeys.value.includes('AuthStore')) {
        return {
            token: undefined,
        };
    }
    const { value } = yield SecureStoragePlugin.get({ key: 'AuthStore' }).catch(() => ({
        value: undefined,
    }));
    if (value) {
        return JSON.parse(value);
    }
    return {
        token: undefined,
    };
});
export const getAuthorizationToken = () => __awaiter(void 0, void 0, void 0, function* () {
    const { token } = yield getAuthStore();
    return token;
});
